/**
 * 彩易分析 - 系统常量 - 合并导出
 * https://menger.me
 * @大梦
 */

'use strict';

import Default from './Default';
import Customer from './Customer';

export default {
    ...Default,
    ...Customer,
}